/**
 * CurrencyService
 * Service for Currency entity operations
 * Route: api/currency
 * Controller: CurrencyController.cs
 */
import { CrudService } from '../base/CrudService';
export class CurrencyService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? CurrencyService.DEFAULT_SERVICE_PATH,
            basePath: CurrencyService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
CurrencyService.DEFAULT_SERVICE_PATH = 'procurements';
CurrencyService.BASE_PATH = 'api/currency';
//# sourceMappingURL=CurrencyService.js.map